
export class Conta{
    Type: number;
    Banco?: string;
    Agencia: string;
    Numero: string;
    CoTitular?: string;
}